import Header from '../component/header';
import { Hero } from '../component/hero';
import { Footer } from '../component/footer';
import PrivacyPolicy from '../component/privacyPolicy/privacy';

function Privacy() {
  return (
    <>
    <Header/>
    <Hero/>
    <PrivacyPolicy/>
    <Footer/>
    </>
  );
}

export default Privacy;
